import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-55f62584"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "flex align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "pi pi-user"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 2,
  class: "nav-button"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#003D66",
    "fill-opacity": ".9",
    d: "M6 6H2V2h4v4Zm6-4H8v4h4V2Zm6 0h-4v4h4V2ZM6 8H2v4h4V8Zm6 0H8v4h4V8Zm6 0h-4v4h4V8ZM6 14H2v4h4v-4Zm6 0H8v4h4v-4Zm6 0h-4v4h4v-4Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#61C7F2",
    d: "M5 5H3V3h2v2Zm6-2H9v2h2V3Zm6 0h-2v2h2V3ZM5 9H3v2h2V9Zm6 0H9v2h2V9Zm6 0h-2v2h2V9ZM5 15H3v2h2v-2Zm6 0H9v2h2v-2Zm6 0h-2v2h2v-2Z"
  })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#633200",
    "fill-opacity": ".9",
    d: "M10 1c-.83 0-1.5.654-1.5 1.464v.664C5.64 3.791 4 5.994 4 9v6l-2 1.044V17h6a2 2 0 1 0 4 0h6v-.956L16 15V9c0-2.996-1.63-5.209-4.5-5.873v-.663C11.5 1.654 10.83 1 10 1Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#FFD746",
    d: "M15.537 15.887 15 15.606V9c0-2.927-1.621-5.073-5-5.073S5 6.072 5 9v6.606l-.537.28-.218.114H15.755l-.218-.113Z"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#00451D",
    "fill-opacity": ".9",
    d: "M10 1a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#52B812",
    d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#fff",
    d: "M8.723 12.461c-.047-.13-.09-.3-.125-.508a3.618 3.618 0 0 1-.055-.617c0-.317.063-.605.19-.863a3.52 3.52 0 0 1 .478-.723c.19-.224.396-.44.617-.648.22-.208.427-.411.617-.609s.349-.406.477-.625c.128-.219.19-.458.19-.719 0-.234-.046-.438-.14-.613a1.28 1.28 0 0 0-.387-.438 1.745 1.745 0 0 0-.563-.262 2.53 2.53 0 0 0-.674-.086c-.776 0-1.516.347-2.22 1.039V4.984c.855-.5 1.74-.75 2.657-.75.422 0 .82.055 1.195.164.375.109.703.271.984.484.28.213.503.479.664.797.16.318.242.688.242 1.109 0 .401-.067.758-.203 1.07a3.932 3.932 0 0 1-.512.863 4.92 4.92 0 0 1-.664.699c-.237.203-.458.406-.664.609a3.435 3.435 0 0 0-.512.633 1.35 1.35 0 0 0-.203.727 2 2 0 0 0 .086.609c.058.182.114.336.172.461H8.723v.002ZM9.613 15.766c-.297 0-.56-.102-.789-.305a.949.949 0 0 1-.328-.734c0-.297.11-.542.328-.734.224-.208.487-.313.79-.313.296 0 .557.104.78.313a.934.934 0 0 1 .328.734.949.949 0 0 1-.328.734 1.145 1.145 0 0 1-.78.305Z"
  })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"height":"75px"},
  id: "header-bar-spacer"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Button = _resolveComponent("Button")!
  const _component_LoginButton = _resolveComponent("LoginButton")!
  const _component_LogoutButton = _resolveComponent("LogoutButton")!
  const _component_Toolbar = _resolveComponent("Toolbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.isLoggedIn)
              ? (_openBlock(), _createBlock(_component_Avatar, {
                  key: 0,
                  shape: "circle",
                  style: {"border":"2px solid var(--primary-color)"}
                }, {
                  default: _withCtx(() => [
                    (_ctx.img && _ctx.isLoggedIn)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.img
                        }, null, 8, _hoisted_3))
                      : _createCommentVNode("", true),
                    (!_ctx.img && _ctx.isLoggedIn)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.webId)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: _ctx.webId,
                class: "no-tap-highlight hidden sm:inline-block ml-2"
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.name), 1)
              ], 8, _hoisted_5))
            : _createCommentVNode("", true),
          (_ctx.webId)
            ? (_openBlock(), _createBlock(_component_Divider, {
                key: 1,
                layout: "vertical"
              }))
            : _createCommentVNode("", true),
          (_ctx.webId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Demands"))
            : _createCommentVNode("", true)
        ]),
        end: _withCtx(() => [
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "p-button-rounded p-button-text ml-1 mr-1 no-tap-highlight"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                class: _normalizeClass(["p-button-rounded p-button-text ml-1 mr-1 no-tap-highlight", { 'p-button-secondary': !_ctx.hasActivePush }])
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true),
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                class: "p-button-rounded p-button-text ml-1 mr-1 no-tap-highlight"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isLoggedIn)
            ? (_openBlock(), _createBlock(_component_LoginButton, { key: 3 }))
            : (_openBlock(), _createBlock(_component_LogoutButton, { key: 4 }))
        ]),
        _: 1
      })
    ]),
    _hoisted_10
  ], 64))
}